import { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'raviger';
import Moment from 'react-moment';
import moment from 'moment';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Button, Card, Form as BootstrapForm, ListGroup, Modal, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import { Field, Formik } from "formik";
import * as Yup from 'yup';
import { Switch } from 'formik-mui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan, faCar, faUpload, faEdit, faEnvelope, faHouseDamage,
  faKey, faMapMarkedAlt, faPlusSquare, faTimes, faTrailer, faUserPlus, faUsers, faMinusCircle,
  faCircle, faExclamationCircle, faQuestionCircle, faHome, faHeart, faSkullCrossbones, faReply
} from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import MaterialCheckbox from '@mui/material/Checkbox';
import { makeStyles } from '@mui/styles';
import { faCalendarEdit, faFileBracketsCurly, faHomeHeart, faRightLeft, faMessagePlus, faCommentSmile, faLocationPlus, faClockRotateLeft, faCircleBolt, faHomeAlt } from '@fortawesome/pro-solid-svg-icons';
import Header from '../components/Header';
import History from '../components/History';
import { capitalize } from '../utils/formatString';
import { Checkbox, DateTimePicker, TextInput } from '../components/Form';
import AnimalCards from '../components/AnimalCards';
import PhotoDocuments from '../components/PhotoDocuments';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import ShelterlyPrintifyButton from "../components/ShelterlyPrintifyButton";
import LoadingLink from "../components/LoadingLink";
import ActionsDropdown from '../components/ActionsDropdown';
import { useLocationWithRoutes } from '../hooks';
import { printServiceRequestSummary, printSrAnimalCareSchedules } from './Utils';

import '../assets/styles.css';
import { faLocationXmark } from '@fortawesome/pro-regular-svg-icons';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    color: 'white',
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: '#DFDDDD',
      cursor: 'not-allowed',
      pointerEvents: 'all !important',
      title: 'test'
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  checked: {},
});

function ServiceRequestDetails({ id, incident, organization }) {

  const classes = useStyles();

  const { state } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(true);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const { getFullLocationFromPath } = useLocationWithRoutes();
  const datetime = useRef(null);
  const [returnRequestedShow, setReturnRequestedShow] = useState(false);
  const handleReturnRequestedClose = () => setReturnRequestedShow(false);
  const [selectedAnimals, setSelectedAnimals] = useState([]);

  const openCalendar = () => {
    setTimeout(() => datetime.current.flatpickr.open(), 0);
  }
  const priorityText = {1:'Urgent', 2:'High', 3:'Medium', 4:'Low', 5:'Lowest'};

  const cancelServiceRequest = () => {
    setIsLoading(true);
    axios.patch('/hotline/api/servicerequests/' + data.id + '/', {status:'canceled'})
      .finally(() => setIsLoading(false));
    setData(prevState => ({ ...prevState, 'status':'Canceled', 'animals':prevState['animals'].map(animal => ({...animal, status:'CANCELED'}))}));
    setShowModal(false)
  }

  const handleReopenSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/hotline/api/servicerequests/'+ data.id + '/', {status:'open'})
    .then(response => {
      let updated_history = [...data.action_history];
      updated_history.unshift(moment(new Date()).format('MMM-DD-YYYY') + ". " + state.user.first_name + " " + state.user.last_name + " reopened this service request. (0 minutes ago)");
      setData(prevState => ({ ...prevState, "status":"open", action_history:updated_history }));
      handleReopenModalClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  const [data, setData] = useState({
    id: '',
    id_for_incident: '',
    animals: [],
    owners: [],
    owner_objects: [],
    reporter: '',
    reporter_object: {first_name:'', last_name:'', display_phone:''},
    directions: '',
    priority: '',
    address: '',
    full_address: '',
    apartment: '',
    city: '',
    state: '',
    zip_code: '',
    verbal_permission: false,
    key_provided: false,
    accessible: false,
    turn_around: false,
    followup_date: null,
    assigned_requests: [],
    status: '',
    notes: [],
    images: [],
    action_history: [],
  });

  const [existingSRs, setExistingSRs] = useState({data:{}, options:[], fetching:true});
  const [noteData, setNoteData] = useState({'open':new Date(), 'urgent': true, 'notes':'', 'author':state ? state.user.id : 'undefined', 'service_request':data.id});

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showModal, setShowModal] = useState(false);
  const [showCaltopoModal, setShowCaltopoModal] = useState(false);
  const [caltopoResults, setCaltopoResults] = useState('');
  const [showTransfer, setShowTransfer] = useState(false);
  const handleCloseTransfer = () => {setShowTransfer(false);setIsLoading(false);};
  const [transferData, setTransferData] = useState({'new_request_id':null, 'new_request_id_for_incident': null, 'animal_ids':[]});
  const [showNoteModal, setShowNoteModal] = useState(false);
  const handleCloseNoteModal = () => {setNoteData({'open':new Date(), 'urgent': true, 'notes':'', 'author':state ? state.user.id : 'undefined', 'service_request':data.id});setShowNoteModal(false);};
  const [showReopenModal, setShowReopenModal] = useState(false)
  const handleReopenModalClose = () => {setShowReopenModal(false);}
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const handleCloseRemoveModal = () => setShowRemoveModal(false);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const handleCloseSRModal = () => setShowCloseModal(false);

  // Handle animal reunification submit.
  const handleSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/hotline/api/servicerequests/' + data.id + '/', {reunite_animals:true})
    .then(response => {
      setData(prevState => ({ ...prevState, "status":"Closed", "animals":prevState['animals'].map(animal => ({...animal, status:animal.status !== 'DECEASED' ? 'REUNITED' : 'DECEASED'})) }));
      handleClose()
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal return requested submit.
  const handleReturnRequestedSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/hotline/api/servicerequests/' + data.id + '/', {return_animals:selectedAnimals})
    .then(response => {
      setData(prevState => ({ ...prevState, "status":data.status === "Closed" ? "Open" : data.status, "animals":prevState['animals'].map(animal => ({...animal, status:selectedAnimals.includes(animal.id) ? 'RETURN REQUESTED' : animal.status})) }));
      handleReturnRequestedClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  function buildAnimalUrl(animal) {
    return getFullLocationFromPath(`/${organization}/${incident}/animals/${animal.id_for_incident}`)
  }

  const handleDownloadPdfClick = async () => {
    setIsLoading(true);
    // wait for 1 tick so spinner will set before the print button locks up the browser
    await new Promise(resolve => setTimeout(resolve, 0));
    printServiceRequestSummary(data)
      .finally(() => setIsLoading(false));
  }

  const handlePrintAllAnimalsClick = () => {
    setIsLoading(true);
    const animals = data.animals.map((animal) => ({
      ...animal,
      url: buildAnimalUrl(animal)
    }));
    return printSrAnimalCareSchedules(animals, id, setIsLoading);
  }

  const handleGeoJsonDownload = () => {
    setIsLoading(true);
    var fileDownload = require('js-file-download');
    axios.get('/hotline/api/servicerequests/' + data.id +'/download/', {
            responseType: 'blob',
        }).then(res => {
            fileDownload(res.data, 'SR-' + id + '.geojson');
        }).catch(err => {
        }).finally(() => setIsLoading(false));
  }

  const handleGeoJsonPush = () => {
    setIsLoading(true);
    axios.get('/hotline/api/servicerequests/' + data.id + '/push/', {
            responseType: 'json',
        }).then(res => {
          setShowCaltopoModal(true); 
          const successfulCount = Object.values(res.data).filter(item => item.status === true).length;
          const totalCount = Object.values(res.data).length;
          setCaltopoResults('Pushed ' + successfulCount + ' out of ' + totalCount +' Service Request(s) successfully.');
        }).catch(err => {
        }).finally(() => setIsLoading(false));
  }

  const handleSRRemove = () => {
    axios.get('/hotline/api/servicerequests/' + data.id + '/remove_active/')
    .then(response => {
      setData(prevState => ({ ...prevState, "status":response.data.status, "assigned_requests":response.data.assigned_requests, "followup_date":response.data.followup_date }));
      handleCloseRemoveModal();
    })
    .catch(error => {
      setShowSystemError(true);
    })
  }

  const handleSRClose = () => {
    axios.patch('/hotline/api/servicerequests/' + data.id + '/', {status:'closed'})
    .then(response => {
      let updated_history = [...data.action_history];
      updated_history.unshift(moment(new Date()).format('MMM-DD-YYYY') + ". " + state.user.first_name + " " + state.user.last_name + " closed this service request. (0 minutes ago)");
      setData(prevState => ({ ...prevState, "status":"closed", action_history:updated_history }));
      handleCloseSRModal();
    })
    .catch(error => {
      setShowSystemError(true);
    })
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    setIsLoading(true);

    const fetchServiceRequestData = async () => {
      // Fetch ServiceRequest data.
      await axios.get('/hotline/api/incident/' + (state ? state.incident.id : 'undefined')  + '/servicerequests/' + id + '/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      })
      .finally(() => setIsLoading(false));
    };
    fetchServiceRequestData();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id]);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchExistingSRData = async () => {
      setIsLoading(true);
      // Fetch all owners data.
      let service_requests = [];
      if (!unmounted) {
        let options = [];
        let nextUrl = '/hotline/api/servicerequests/?light=true&incident=' + incident + '&organization=' + organization;
        do {
          const response = await axios.get(nextUrl, {
            cancelToken: source.token,
          })
          .catch(error => {
            if (error.response) {
              setShowSystemError(true);
            }
            setIsLoading(false);
          });

          response.data.results.filter(request => request.status !== 'canceled' && request.id_for_incident !== Number(id)).forEach(request => {
            options.push({id: request.id, id_for_incident: request.id_for_incident, label: 'SR#' + request.id_for_incident + ': ' + request.full_address})
          })

          service_requests.push(...response.data.results);
          nextUrl = response.data.next;
          if (nextUrl) {
            nextUrl = '/hotline/' + response.data.next.split('/hotline/')[1];
          }
        } while(nextUrl != null)

        setExistingSRs({data:service_requests, options:options, fetching:false});
        setIsLoading(false);
      }
    }
    if (showTransfer) {
      fetchExistingSRData();
    }

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [showTransfer]);

  return (
    <>
      <Header>{`Service Request #${data.id_for_incident || ' - '}`}</Header>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Service Request Cancelation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this Service Request and associated animals?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => cancelServiceRequest()}>
            Yes
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showCaltopoModal} onHide={() => setShowCaltopoModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>CalTopo Results</Modal.Title>
        </Modal.Header>
        <Modal.Body>{ caltopoResults }</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCaltopoModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="row mb-3 gx-3">
        <div className="col-6 d-flex">
          <Card className="border rounded" style={{width:"100%"}}>
            <Card.Body style={{marginTop:"-10px"}}>
              <div className="d-flex justify-content-between" style={{marginBottom:"-10px"}}>
                <h4 style={{paddingTop:"5px"}}>Information&nbsp;
                  {data.verbal_permission ?
                  <OverlayTrigger
                    key={"verbal"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-verbal`}>
                        Verbal Liability Release
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faCommentSmile} size="sm" className="fa-move-up" transform={'shrink-2'} />
                  </OverlayTrigger> : ""
                  }
                  {data.key_provided ?
                  <OverlayTrigger
                    key={"key"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-key`}>
                        Key at staging
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faKey} size="sm" className="" transform={'shrink-2'} />
                  </OverlayTrigger> : ""
                  }
                  {data.accessible === "yes" ?
                  <OverlayTrigger
                    key={"accessible"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-accessible`}>
                        Easily accessible
                      </Tooltip>
                    }
                  >
                    <span className="fa-layers">
                      <FontAwesomeIcon icon={faCar} size="sm" className="fa-move-down" />
                    </span>
                  </OverlayTrigger> : data.accessible === "no" ?
                  <OverlayTrigger
                    key={"not-accessible"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-not-accessible`}>
                        Not easily accessible
                      </Tooltip>
                    }
                  >
                    <span className="fa-layers" style={{marginLeft:"2px"}}>
                      <FontAwesomeIcon icon={faCar} size="sm" className="fa-move-down" />
                      <FontAwesomeIcon icon={faBan} color="#ef5151" size="sm" transform={'shrink-1'} />
                    </span>
                  </OverlayTrigger>
                  : ""}
                  {data.turn_around === "yes" ?
                  <OverlayTrigger
                    key={"turnaround"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-turnaround`}>
                        Room to turn around
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faTrailer} size="sm" className="ms-1" />
                  </OverlayTrigger> : data.turn_around === "no" ?
                  <OverlayTrigger
                    key={"no-turnaround"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-no-turnaround`}>
                        No room to turn around
                      </Tooltip>
                    }
                  >
                    <span className="fa-layers ms-1">
                      <FontAwesomeIcon icon={faTrailer} size="sm" />
                      <FontAwesomeIcon icon={faBan} color="#ef5151" size="sm" transform={'shrink-1'} />
                    </span>
                  </OverlayTrigger> : ""}
                </h4>
                {isLoading ? (
                  <Spinner
                    className="align-self-center me-3"
                    {...{
                      as: 'span',
                      animation: 'border',
                      size: undefined,
                      role: 'status',
                      'aria-hidden': 'true',
                      variant: 'light',
                      style: {
                        height: '1.5rem',
                        width: '1.5rem',
                        marginBottom: '0.75rem'
                      }
                    }}
                  />
                ) : (
                  <ActionsDropdown variant="secondary" title="Actions">
                    <LoadingLink
                      href={"/" + organization + "/" + incident + "/hotline/servicerequest/edit/" + data.id_for_incident}
                      isLoading={isLoading}
                      className="d-block"
                      label="Update Service Request"
                    >
                      <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                    </LoadingLink>
                    <ShelterlyPrintifyButton
                      id="service-request-summary"
                      spinnerSize={2.0}
                      tooltipPlacement='right'
                      label='Download Service Request Summary'
                      printFunc={handleDownloadPdfClick}
                      disabled={isLoading}
                      noOverlay={true}
                    />
                    <LoadingLink label="Download Service Request as Geojson" onClick={handleGeoJsonDownload} isLoading={isLoading} className="d-block">
                      <FontAwesomeIcon icon={faFileBracketsCurly} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                      onClick={() => {setShowNoteModal(true)}}
                      isLoading={isLoading}
                      className="d-block"
                      label="Add Service Request Note"
                    >
                      <FontAwesomeIcon icon={faMessagePlus} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                      href={"/" + organization + "/" + incident + "/hotline/servicerequest/" + id + "/assign"}
                      isLoading={isLoading}
                      className="d-block"
                      label={(data.assigned_requests.filter(assigned_request => !assigned_request.dispatch_assignment.end_time).length ? "Reassign" : "Assign") + " Service Request to FA"}
                      disabled={!["open", "assigned"].includes(data.status)}
                      disabled_text="Service Request is closed."
                    >
                      <FontAwesomeIcon icon={faMapMarkedAlt} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                      onClick={() => {setShowRemoveModal(true)}}
                      isLoading={isLoading}
                      className="d-block"
                      label="Remove Service Request from FA"
                      disabled={data.status !== 'assigned'}
                      disabled_text="Service Request does not belong to an active Field Assignment."
                    >
                      <FontAwesomeIcon icon={faLocationXmark} className="fas" inverse />
                    </LoadingLink>
                    {state && state.incident.caltopo_map_id && data.status != 'closed' ?
                    <LoadingLink label="Push Service Request to CalTopo" onClick={handleGeoJsonPush} isLoading={isLoading} className="d-block">
                      <FontAwesomeIcon icon={faUpload} className="fas" inverse />
                    </LoadingLink>
                    : ''}
                    {data.animals.filter(animal => ['NO FURTHER ACTION', 'SHELTERED', 'REUNITED', 'DECEASED'].includes(animal.status)).length === data.animals.length && data.status === 'open' ? <LoadingLink
                      onClick={() => {setShowCloseModal(true)}}
                      isLoading={isLoading}
                      className="d-block"
                      label="Close Service Request"
                      disabled={data.animals.filter(animal => !['NO FURTHER ACTION', 'SHELTERED', 'REUNITED', 'DECEASED'].includes(animal.status)).length === data.animals.length}
                      disabled_text={data.animals.filter(animal => !['NO FURTHER ACTION', 'SHELTERED', 'REUNITED', 'DECEASED'].includes(animal.status)).length === data.animals.length ? "All animals must be in a final state before closing a service request." : "Service Request status must be open and not assigned in order to close."}
                    >
                      <FontAwesomeIcon icon={faTimes} className="fas" size="lg" style={{cursor:'pointer'}} inverse />
                    </LoadingLink> : ""}
                    {data.status === 'closed' ? <LoadingLink
                      onClick={() => {setShowReopenModal(true)}}
                      isLoading={isLoading}
                      className="d-block"
                      label="Reopen Service Request"
                    >
                      <FontAwesomeIcon icon={faClockRotateLeft} className="fas" style={{marginLeft:"-2px"}} inverse />
                    </LoadingLink> : ""}
                    <LoadingLink label="Cancel Service Request" onClick={() => {setShowModal(true)}} isLoading={isLoading} className="d-block">
                      <FontAwesomeIcon icon={faBan} className="fas" style={{cursor:'pointer', marginLeft:"-1px"}} inverse />
                    </LoadingLink>
                  </ActionsDropdown>
                )}
              </div>
              <p className="phr"/>
              <ListGroup variant="flush">
                <ListGroup.Item style={{marginTop:"-13px"}}>
                  <div className="row">
                    <span className="col-6"><b>Priority: </b><span style={{color: data.priority === 1 ? 'red' : 'white'}}>{priorityText[data.priority]}</span></span>
                    <span className="col-6" style={{textTransform:"capitalize"}}><b>Status: </b>{data.status}</span>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item><b>Address: </b>{data.full_address}</ListGroup.Item>
                <ListGroup.Item>
                  <b>Followup Date: </b>
                  {data.followup_date ?
                  <span>
                    <FontAwesomeIcon icon={faCalendarEdit} className="ms-1 me-1" style={{cursor:'pointer'}} onClick={() => openCalendar()} />
                    <Moment format="ll" style={{color: data.overdue ? '#BF1919' : 'white'}}>{data.followup_date}</Moment>
                  </span>
                  : "N/A"}
                  <Flatpickr
                    ref={datetime}
                    name="followup_date"
                    id="followup_date"
                    options={{clickOpens:false, altInput:true, altInputClass:"hide-input", altFormat:"F j, Y"}}
                    onChange={(date, dateStr) => {
                      setData(prevState => ({ ...prevState, "followup_date":dateStr }));
                      axios.patch('/hotline/api/servicerequests/' + data.id + '/', {followup_date:date[0].toJSON().slice(0, 10)})
                      .catch(error => {
                        setShowSystemError(true);
                      });
                    }}
                    value={data.followup_date || null}>
                  </Flatpickr>
                </ListGroup.Item>
                <ListGroup.Item style={{marginBottom:"-13px"}}><b>Instructions for Field Team:</b> {data.directions||"None"}</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </div>
        <div className="col-6 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body style={{marginTop:"-10px", marginBottom:"-15px"}}>
              <div className="d-flex justify-content-between" style={{marginBottom:"-10px"}}>
                <h4 style={{paddingTop:"5px"}}>Contacts</h4>
                {isLoading ? (
                    <Spinner
                      className="align-self-center me-3"
                      {...{
                        as: 'span',
                        animation: 'border',
                        size: undefined,
                        role: 'status',
                        'aria-hidden': 'true',
                        variant: 'light',
                        style: {
                          height: '1.5rem',
                          width: '1.5rem',
                          marginBottom: '0.75rem'
                        }
                      }}
                    />
                  ) : (
                    <ActionsDropdown variant="secondary" title="Actions">
                      <LoadingLink
                        href={"/" + organization + "/" + incident + "/people/owner/new?servicerequest_id=" + data.id_for_incident}
                        isLoading={isLoading}
                        className="d-block"
                        label="Add Owner to SR and Animals"
                      >
                        <FontAwesomeIcon icon={faPlusSquare} className="fas" inverse />
                      </LoadingLink>
                    </ActionsDropdown>
                  )}
              </div>
              <p className="phr"/>
              <ListGroup variant="flush" style={{marginTop:"-13px"}}>
                {data.owner_objects.map(owner => (
                  <ListGroup.Item key={owner.id}><b>Owner: </b><Link href={"/" + organization + "/" + incident + "/people/owner/" + owner.id} className="text-link" style={{textDecoration:"none", color:"white"}}>{owner.first_name} {owner.last_name}</Link>
                    {owner.display_phone ?
                      <span>&nbsp;{owner.display_phone}</span>
                    : ""}
                    {owner.email ?
                    <OverlayTrigger
                      key={"owner-email"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-owner-email`}>
                          Email: {owner.email}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faEnvelope} className="ms-1" inverse />
                    </OverlayTrigger>
                    : ""}
                  </ListGroup.Item>
                ))}
                {data.reporter ?
                <ListGroup.Item style={{marginBottom:"-13px"}}>
                  <b>Reporter: </b><Link href={"/" + organization + "/" + incident + "/people/reporter/" + data.reporter} className="text-link" style={{textDecoration:"none", color:"white"}}>{data.reporter_object.first_name} {data.reporter_object.last_name}</Link>
                  {data.reporter_object.agency ? <span className="ms-1">({data.reporter_object.agency})</span> : "" }
                  {data.reporter_object.display_phone ?
                    <span>&nbsp;{data.reporter_object.display_phone}</span>
                  : ""}
                </ListGroup.Item> : ""}
              </ListGroup>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-12 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body style={{marginTop:"-10px", marginBottom:"-15px"}}>
              <div className="d-flex justify-content-between" style={{marginBottom:"-10px"}}>
                <h4 style={{paddingTop:"5px"}}>Animals</h4>
                {isLoading ? (
                    <Spinner
                      className="align-self-center me-3"
                      {...{
                        as: 'span',
                        animation: 'border',
                        size: undefined,
                        role: 'status',
                        'aria-hidden': 'true',
                        variant: 'light',
                        style: {
                          height: '1.5rem',
                          width: '1.5rem',
                          marginBottom: '0.75rem'
                        }
                      }}
                    />
                  ) : (
                    <ActionsDropdown variant="secondary" title="Actions">
                      {data.animals.length > 0 ?
                        <ShelterlyPrintifyButton
                          id="animal-details-all-animal-care-schedules"
                          spinnerSize={2.0}
                          tooltipPlacement='right'
                          label='Download All Animal Care Schedules'
                          printFunc={handlePrintAllAnimalsClick}
                          disabled={isLoading}
                          noOverlay={true}
                        />
                      : ""}
                      <LoadingLink
                        href={"/" + organization + "/" + incident + "/animals/new?servicerequest_id=" + data.id}
                        isLoading={isLoading}
                        className="d-block"
                        label="Add an Animal"
                      >
                        <FontAwesomeIcon icon={faPlusSquare} className="fas" inverse />
                      </LoadingLink>
                      {data.animals.length > 0 ?
                      <LoadingLink label="Transfer Animals Betweens SRs" onClick={() => setShowTransfer(true)} isLoading={isLoading} className="d-block">
                        <FontAwesomeIcon icon={faRightLeft} className="fas" style={{cursor:'pointer'}} inverse />
                      </LoadingLink>
                      : ""}
                      {data.animals.length > 0 && data.status.toLowerCase() === 'open' ?
                        <LoadingLink label="Reunite All Animals" onClick={() => setShow(true)} isLoading={isLoading} className="d-block">
                          <FontAwesomeIcon icon={faHomeHeart} className="fas" style={{cursor:'pointer'}} inverse />
                        </LoadingLink>
                      : ""}
                      {data.animals.filter(animal => ['SHELTERED', 'REUNITED'].includes(animal.status)).length ?
                      <LoadingLink label="Mark Animals Return Requested" onClick={() => setReturnRequestedShow(true)} isLoading={isLoading} className="d-block">
                        <FontAwesomeIcon icon={faReply} className="fas" style={{cursor:'pointer'}} inverse />
                      </LoadingLink>
                      : ""}
                    </ActionsDropdown>
                  )}
              </div>
              <p className="phr"/>
              <AnimalCards animals={data.animals} show_owner={false} show_status={true} organization={organization} incident={"/" + incident} />
              {data.animals.length < 1 ? <div className="mb-3">Service Request does not have any animals assigned.</div> : ""}
            </Card.Body>
          </Card>
        </div>
      </div>
      <PhotoDocuments setData={setData} data={data} id={data.id} object="Service Request" url={'/hotline/api/servicerequests/' + data.id + '/'} isLoading={isLoading} />
      <div className="row mt-3">
        <div className="col-12 d-flex">
          <Card className="border rounded" style={{width:"100%"}}>
            <Card.Body>
              <Card.Title>
                <h4 className="mb-0">Visit Log</h4>
              </Card.Title>
              <p className="phr"/>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px", marginLeft:"-15px"}}>
                {data.assigned_requests.filter(assigned_request => !assigned_request.visit_note || !assigned_request.visit_note.date_completed).map(assigned_request => (
                  <ListGroup.Item key={assigned_request.id}>
                    <Link href={"/" + organization + "/" + incident + "/field/summary/" + assigned_request.dispatch_assignment.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}><b>Active FA#{assigned_request.dispatch_assignment.id_for_incident}</b></Link>:&nbsp;
                    {assigned_request.dispatch_assignment.team_name}
                    <OverlayTrigger
                      key={"team-names"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-team-names`}>
                          {assigned_request.dispatch_assignment.team_member_names}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faUsers} className="ms-1 fa-move-down" />
                    </OverlayTrigger>
                    <OverlayTrigger
                      key={"resolve-dispatch-assignment"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-resolve-dispatch-assignment`}>
                          Add visit information
                        </Tooltip>
                      }
                    >
                      <Link href={"/" + organization + "/" + incident + "/field/resolution/" + assigned_request.dispatch_assignment.id_for_incident + "/request/" + data.id_for_incident}><FontAwesomeIcon icon={faLocationPlus} className="ms-1" inverse /></Link>
                    </OverlayTrigger>
                  </ListGroup.Item>
                ))}
                {data.assigned_requests.filter(assigned_request => assigned_request.visit_note && assigned_request.visit_note.date_completed).map((assigned_request) => (
                  <ListGroup.Item key={assigned_request.id}>
                    <Link href={"/" + organization + "/" + incident + "/field/summary/" + assigned_request.visit_note.dispatch_assignment} className="text-link" style={{textDecoration:"none", color:"white"}}><b>FA#{assigned_request.visit_note.dispatch_assignment}</b></Link>:
                    {assigned_request.visit_note.forced_entry ?
                      <OverlayTrigger
                        key={"forced"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-forced`}>
                            Forced entry
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faHouseDamage} size="sm" className="ms-1" style={{marginBottom:"1px"}} />
                      </OverlayTrigger>
                    : ""}
                    {assigned_request.dispatch_assignment.team_name ? <span> {assigned_request.dispatch_assignment.team_name}</span> : ""}
                    <OverlayTrigger
                      key={"team-names-"+id}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-team-names` + id}>
                          {assigned_request.dispatch_assignment.team_member_names}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faUsers} className="ms-1 fa-move-down" />
                    </OverlayTrigger>
                    <OverlayTrigger
                      key={"edit-visit-note"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-edit-visit-note`}>
                          Update visit note
                        </Tooltip>
                      }
                    >
                      <Link href={"/" + organization + "/" + incident + "/field/assignment/note/" + assigned_request.visit_note.id}> <FontAwesomeIcon icon={faEdit} inverse /></Link>
                    </OverlayTrigger>
                    &nbsp;|&nbsp;<Moment format="LL">{assigned_request.visit_note.date_completed}</Moment>
                    <div className="mt-1 mb-0" style={{whiteSpace:"pre-line"}}><b>Outcome:</b> {assigned_request.visit_note.notes||"No visit information available."}</div>
                    <div className="mt-1 mb-0"><b>Owner Notified of Outcome: </b>{assigned_request.owner_contacted ? "Yes" : "No"}</div>
                  </ListGroup.Item>
                ))}
                {data.assigned_requests.filter(assigned_request => assigned_request.visit_note).length < 1 ? <div className="mt-2 mb-1 ms-3">Service Request has not been visited yet.</div> : ""}
              </ListGroup>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 d-flex">
          <Card className="border rounded" style={{width:"100%"}}>
            <Card.Body>
              <Card.Title>
                <h4 className="mb-0">Service Request Notes</h4>
              </Card.Title>
              <p className="phr"/>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px", marginLeft:"-15px"}}>
                {data.notes.map(note => (
                  <ListGroup.Item key={note.id}>
                    <div>
                      <b>Created:</b>&nbsp;<Moment format="LLL">{note.open}</Moment>
                      <OverlayTrigger
                        key={"edit-note"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-edit-note`}>
                            Update note
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon onClick={() => {setNoteData(note);setShowNoteModal(true)}} icon={faEdit} className="ms-1" style={{cursor:'pointer'}} inverse />
                      </OverlayTrigger>
                    </div>
                    <div><b>Author:</b>&nbsp;{note.author_name}</div>
                    <div><b>{note.urgent ? 'Shared ' : ''}Note:</b>&nbsp;{note.notes}</div>
                  </ListGroup.Item>
                ))}
                {data.notes.length < 1 ? <div className="mt-2 mb-1 ms-3">Service Request has no notes yet.</div> : ""}
              </ListGroup>
            </Card.Body>
          </Card>
        </div>
      </div>
      <History action_history={data.action_history} />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Animal Reunification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Have all of the animals in this service request been reunited with their owner?
            {data.assigned_requests.filter(assigned_request => !assigned_request.visit_note || !assigned_request.visit_note.date_completed).length === 0 ? <p className="mt-2">This will automatically close the Service Request.</p> : ""}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>Yes</Button>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Formik
        initialValues={transferData}
        enableReinitialize={true}
        // validationSchema={Yup.object({
        // })}
        onSubmit={(values, { setSubmitting }) => {
          axios.patch('/hotline/api/servicerequests/' + data.id + '/', values)
          .then(response => {
            let updated_history = [...data.action_history];
            updated_history.unshift(state.user.first_name + " " + state.user.last_name + " transferred animals to SR#" + String(transferData.new_request_id_for_incident) + " 0 minutes ago.");
            setData(prevState => ({ ...prevState, animals:response.data.animals.filter(animal => !values.animal_ids.includes(animal.id)), action_history:updated_history}));
            setTransferData(prevState => ({ ...prevState, animal_ids:transferData.animal_ids.filter(id => (!values.animal_ids.includes(id)))}));
            setShowTransfer(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }}
      >
      {formikProps => (
      <Modal show={showTransfer} onHide={handleCloseTransfer} aria-modal="true">
        <Modal.Header closeButton>
          <Modal.Title>Transfer Animals Between SRs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {data.animals.map((animal, index) => (
            <div key={animal.id}>
              <Checkbox
                name={`animal_ids`}
                checked={formikProps.values.animal_ids.includes(animal.id) || false}
                onChange={() => {
                  if (formikProps.values.animal_ids.includes(animal.id)) {
                    let newItems = [...transferData.animal_ids];
                    newItems = newItems.filter(id => id !== animal.id);
                    setTransferData(prevState => ({...prevState, animal_ids: newItems}))
                    formikProps.setFieldValue(`animal_ids`, newItems);
                  }
                  else {
                    let newItems = [...transferData.animal_ids];
                    newItems.push(animal.id);
                    setTransferData(prevState => ({...prevState, animal_ids: newItems}));
                    formikProps.setFieldValue(`animal_ids`, newItems);
                  }
                }}
                style={{
                  transform: "scale(1.5)",
                  marginTop: "-4px"
                }}
              />
              A#{animal.id_for_incident} - {animal.animal_count > 1 ? <span>{animal.animal_count} {capitalize(animal.species_string)}</span> : <span>{animal.name||"Unknown Name"}&nbsp;-&nbsp;{capitalize(animal.species_string)}</span>}</div>
          ))}
          <label className="mt-3 mb-2">To Service Request:</label>
          <Typeahead
            id="new_request_id"
            onChange={(values) => {
              if (values.length) {
                setTransferData(prevState => ({...prevState, 'new_request_id':values[0].id, 'new_request_id_for_incident':values[0].id_for_incident}));
                // setData(existingSRs.data.filter(request => request.id === values[0].id)[0])
              }
              else {
                setTransferData(prevState => ({...prevState, 'new_request_id':null, 'new_request_id_for_incident':null}));
              }
            }}
            options={existingSRs.options}
            placeholder={existingSRs.fetching ? "Loading..." : "Search..."}
            disabled={existingSRs.fetching ? true : false}
            emptyLabel="No matches found."
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}} disabled={!transferData.new_request_id || transferData.animal_ids.length === 0}>Transfer</Button>
          <Button variant="secondary" onClick={handleCloseTransfer}>Close</Button>
        </Modal.Footer>
      </Modal>
      )}
    </Formik>
    <Formik
      initialValues={noteData}
      enableReinitialize={true}
      validationSchema={Yup.object({
        notes: Yup.string().required('Required.')
          .max(2500, 'Must be 2500 characters or less'),
      })}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        // Set actual SR ID instead of ID for incident.
        values['service_request'] = data.id;
        if (values.id) {
          axios.patch('/hotline/api/requestnote/' + values.id + '/', values)
          .then(response => {
            let updated_notes = [...data.notes];
            updated_notes.forEach(note => {
              if (note.id === values.id) {
                note.urgent = values.urgent;
                note.open = values.open;
                note.notes = values.notes;
              }
            });
            setData(prevState => ({ ...prevState, notes:updated_notes}));
            resetForm();
            setNoteData({'open':null, 'urgent': true, 'notes':'', 'author':state.user.id, 'service_request':data.id});
            setShowNoteModal(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }
        else {
          axios.post('/hotline/api/requestnote/', values)
          .then(response => {
            let updated_notes = [...data.notes];
            updated_notes.unshift(response.data);
            setData(prevState => ({ ...prevState, notes:updated_notes}));
            resetForm();
            setNoteData({'open':new Date(), 'urgent': true, 'notes':'', 'author':state.user.id, 'service_request':data.id});
            setShowNoteModal(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }
      }}
    >
    {formikProps => (
    <Modal show={showNoteModal} onHide={handleCloseNoteModal} aria-modal="true">
      <Modal.Header closeButton>
        <Modal.Title>{formikProps.values.id ? "Update" : "Add"} Service Request Note</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <DateTimePicker
            label="Created"
            name={`open`}
            id={`open`}
            xs="4"
            data-enable-time={true}
            clearable={false}
            onChange={(date, dateStr) => {
              formikProps.setFieldValue(`open`, dateStr)
            }}
            setFieldValue={formikProps.setFieldValue}
            disabled={false}
            value={formikProps.values.open ? formikProps.values.open : new Date()}
          />
        </Row>
        <Row className="mt-3">
          <TextInput
            as="textarea"
            rows={5}
            label="Note"
            name="notes"
            id="notes"
            xs="12"
          />
        </Row>
        <div><BootstrapForm.Label htmlFor="urgent" className="mt-3">Share to Field Team</BootstrapForm.Label></div>
        <div style={{marginLeft:"-10px", marginTop:"-5px"}}><Field component={Switch} name="urgent" type="checkbox" color="primary" /></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {formikProps.submitForm();}} disabled={!formikProps.values.notes}>Save</Button>
        <Button variant="secondary" onClick={handleCloseNoteModal}>Close</Button>
      </Modal.Footer>
    </Modal>
    )}
    </Formik>
    <Modal show={showRemoveModal} onHide={handleCloseRemoveModal}>
      <Modal.Header closeButton>
        <Modal.Title>Remove SR from Active Field Assignment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you would like to remove this SR from its active field assignment?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleSRRemove();}}>Yes</Button>
        <Button variant="secondary" onClick={handleCloseRemoveModal}>No</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showCloseModal} onHide={handleCloseSRModal}>
      <Modal.Header closeButton>
        <Modal.Title>Close Service Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you would like to close this Service Request?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleSRClose();}}>Yes</Button>
        <Button variant="secondary" onClick={handleCloseSRModal}>No</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showReopenModal} onHide={handleReopenModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Service Request Reopen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to reopen this service request?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleReopenSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handleReopenModalClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={returnRequestedShow} onHide={handleReturnRequestedClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Mark Animals Return Requested</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please choose which animals you would like to change to Return Requested:
        </p>
        {data.animals.filter(animal => ['SHELTERED', 'REUNITED'].includes(animal.status)).map(animal => (
          <div key={animal.id} className="mt-1 mb-1" style={{height:"50px"}}>
            <div className="card-header rounded" style={{paddingLeft:"12px", height:"50px"}}>
              <MaterialCheckbox
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                slotProps={{ input: { 'aria-label': 'decorative radio' } }}
                checked={selectedAnimals.includes(animal.id) || false}
                onChange={() => {
                  if (selectedAnimals.includes(animal.id)) {
                    let newItems = [...selectedAnimals];
                    newItems = newItems.filter(id => id !== animal.id);
                    setSelectedAnimals(newItems);
                    // formikProps.setFieldValue(`animal_ids`, newItems);
                  }
                  else {
                    let newItems = [...selectedAnimals];
                    newItems.push(animal.id);
                    setSelectedAnimals(newItems);
                    // formikProps.setFieldValue(`animal_ids`, newItems);
                  }
                }}
                style={{
                  transform: "scale(1.5)",
                  marginTop: "-4px",
                  marginLeft:"-12px"
                }}
                // sx={{
                //   marginLeft: '0px !important',
                // }}
              />
              <label>
                A#{animal.id_for_incident} - {animal.animal_count > 1 ? <span>{animal.animal_count} {capitalize(animal.species_string)}&nbsp;</span> : <span>{animal.name||"Unknown"}&nbsp;-&nbsp;{capitalize(animal.species_string)}&nbsp;</span>}
                {animal.status === "SHELTERED IN PLACE" ?
                  <OverlayTrigger key={"sip"} placement="top"
                                  overlay={<Tooltip id={`tooltip-sip`}>SHELTERED IN PLACE</Tooltip>}>
                      <span className="fa-layers fa-fw">
                        <FontAwesomeIcon icon={faCircle} transform={'grow-1'} />
                        <FontAwesomeIcon icon={faHomeAlt} style={{color:"#444"}} transform={'shrink-3'} size="sm" inverse />
                      </span>
                  </OverlayTrigger> : ""}
                {animal.status === "REPORTED" ?
                  <OverlayTrigger key={"reported"} placement="top"
                                  overlay={<Tooltip id={`tooltip-reported`}>REPORTED</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faExclamationCircle} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "REPORTED (EVAC REQUESTED)" ?
                  <OverlayTrigger key={"reported-evac"} placement="top"
                                  overlay={<Tooltip id={`tooltip-reported-evac`}>REPORTED (EVAC REQUESTED)</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faCircleBolt} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "REPORTED (SIP REQUESTED)" ?
                  <OverlayTrigger key={"reported-sip"} placement="top"
                                  overlay={<Tooltip id={`tooltip-reported-sip`}>REPORTED (SIP REQUESTED)</Tooltip>}>
                    <span className="fa-layers" style={{marginRight:"6px"}}>
                      <FontAwesomeIcon icon={faCircle} className="icon-border" transform={'grow-2'} />
                      <FontAwesomeIcon icon={faHomeAlt} style={{color:"#444"}} transform={'shrink-5 left-1'} inverse />
                    </span>
                  </OverlayTrigger> : ""}
                {animal.status === "UNABLE TO LOCATE" ?
                  <OverlayTrigger key={"unable-to-locate"} placement="top"
                                  overlay={<Tooltip id={`tooltip-unable-to-locate`}>UNABLE TO LOCATE</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faQuestionCircle} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "NO FURTHER ACTION" ?
                  <OverlayTrigger key={"unable-to-locate-nfa"} placement="top"
                                  overlay={<Tooltip id={`tooltip-unable-to-locate-nfa`}>NO FURTHER ACTION</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faMinusCircle} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "REUNITED" ?
                  <OverlayTrigger key={"reunited"} placement="top"
                                  overlay={<Tooltip id={`tooltip-reunited`}>REUNITED</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faHeart} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "SHELTERED" ?
                  <OverlayTrigger key={"sheltered"} placement="top"
                                  overlay={<Tooltip id={`tooltip-sheltered`}>SHELTERED</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faHome} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "DECEASED" ?
                  <OverlayTrigger key={"deceased"} placement="top"
                                  overlay={<Tooltip id={`tooltip-deceased`}>DECEASED</Tooltip>}>
                      <FontAwesomeIcon className="animal-icon" icon={faSkullCrossbones} inverse/>
                  </OverlayTrigger> : ""}
                {animal.status === "RETURN REQUESTED" ?
                  <OverlayTrigger key={"return-requested"} placement="top"
                                  overlay={<Tooltip id={`tooltip-return-requested`}>RETURN REQUESTED</Tooltip>}>
                    <span className="fa-layers" style={{marginRight:"6px"}}>
                      {/* <FontAwesomeIcon icon={faCircle} className="icon-border" transform={'grow-2'} /> */}
                      <FontAwesomeIcon icon={faReply} className="" inverse />
                      {/* <FontAwesomeIcon icon={faHomeAlt} style={{color:"#444"}} transform={'shrink-5 left-1'} inverse /> */}
                    </span>
                  </OverlayTrigger> : ""}
              </label>
            </div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleReturnRequestedSubmit()}} disabled={isLoading}>{isLoading ? "Sending..." : "Select"}</Button>
        <Button variant="secondary" onClick={handleReturnRequestedClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default ServiceRequestDetails;
